import { Text, Box } from "@chakra-ui/react";
import capsule from "../../assets/capsule.svg";
import { CustomHeading, RectangleImage, BoxWithBgColor } from "../CustomComponents/CustomComponents";

const HomeRectangles = () => {
  return (
    <Box>
      <BoxWithBgColor mt={3} mb={2}>
        <CustomHeading fontSize={[20, 28]} pt={4}>
          Capsule
          <Text as="sup" mt={2} fontFamily="sequel-sans-semi-bold-disp">
            s
          </Text>
        </CustomHeading>
        <CustomHeading fontSize={[32, 50]}>A private privacy.</CustomHeading>
        <RectangleImage src={capsule} alt="capsule" h={[450, 500]} w={[400, 600]} />
      </BoxWithBgColor>

      <BoxWithBgColor my={2} display="none">
        <CustomHeading pt={6}>Kickstarter</CustomHeading>
        <RectangleImage src={capsule} alt="capsule" h={[450, 500]} w={[400, 600]} />
      </BoxWithBgColor>
    </Box>
  );
};

export default HomeRectangles;
